export default {
      id: "user_app-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#user_app",
      toString: function () {
        return this.url;
      }
    }